var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07872 8.81269C8.07872 9.21838 8.40759 9.54726 8.81328 9.54726C9.21897 9.54726 9.54785 9.21838 9.54785 8.81269C9.54785 8.407 9.21897 8.07813 8.81328 8.07813C8.40759 8.07813 8.07872 8.407 8.07872 8.81269Z",
    stroke: "#616E85",
    strokeWidth: 1.28549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07872 13.9572C8.07872 14.3629 8.40759 14.6918 8.81328 14.6918C9.21897 14.6918 9.54785 14.3629 9.54785 13.9572C9.54785 13.5515 9.21897 13.2227 8.81328 13.2227C8.40759 13.2227 8.07872 13.5515 8.07872 13.9572Z",
    stroke: "#616E85",
    strokeWidth: 1.28549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07872 3.67207C8.07872 4.07776 8.40759 4.40664 8.81328 4.40664C9.21897 4.40664 9.54785 4.07776 9.54785 3.67207C9.54785 3.26638 9.21897 2.9375 8.81328 2.9375C8.40759 2.9375 8.07872 3.26638 8.07872 3.67207Z",
    stroke: "#616E85",
    strokeWidth: 1.28549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/ThreeDots.0cbdcdcd59bc5aff1eafd2e7e726d96b.svg";
export { ForwardRef as ReactComponent };